import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20watercolor%20wash%20in%20soft%20rose%20and%20cream%20tones%2C%20elegant%20flowing%20texture%2C%20dreamy%20romantic%20atmosphere%2C%20literary%20artistic%20background%2C%20no%20text&width=1400&height=600&seq=cta-bg-wenai&orientation=landscape"
          alt="文爱社区 CTA 背景"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-500/85 to-primary-600/70"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
          准备好开始你的文字之旅了吗？
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
          加入文爱社区，与50万+热爱文字的朋友一起，在字里行间寻找温暖与共鸣。
        </p>
        <Link
          to="/about"
          className="inline-block px-8 py-3 rounded-full bg-white text-primary-600 text-sm font-semibold hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          立即加入文爱社区
        </Link>
      </div>
    </section>
  );
}